export default __webpack_public_path__ + "static/media/GT-America-Mono-Regular.437fb574.ttf";